module.exports = __webpack_public_path__ + "img/Photo_7__Construction_Welland_Canal_993_13_17.65ef3469.jpg";